import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, UserCircleIcon, ChatIcon } from '../icons';
import './Footer.css';

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Active state helpers
    const isActive = (path: string) => location.pathname === path || (path !== '/home' && location.pathname.startsWith(path));

    return (
        <div className="footer-container">
            {/* Left: Home */}
            <div
                className={`footer-nav-item ${isActive('/home') ? 'active' : ''}`}
                onClick={() => navigate('/home')}
            >
                <div className="footer-indicator-bar" />
                <div className="footer-icon-wrapper">
                    <HomeIcon size="m" tone={isActive('/home') ? "yellow" : "lightGrey"} />
                </div>
            </div>

            {/* Center: Logo Button */}
            <div
                className={`footer-nav-item ${isActive('/chat') ? 'active' : ''}`}
                onClick={() => navigate('/chat')}
                role="button"
                tabIndex={0}
            >
                <div className="footer-indicator-bar" />
                <div className="footer-icon-wrapper">
                    <ChatIcon size="m" tone={isActive('/chat') ? "yellow" : "lightGrey"} />
                </div>
            </div>

            {/* Right: Profile */}
            <div
                className={`footer-nav-item ${isActive('/profile') ? 'active' : ''}`}
                onClick={() => navigate('/profile')}
            >
                <div className="footer-indicator-bar" />
                <div className="footer-icon-wrapper">
                    <UserCircleIcon size="m" tone={isActive('/profile') ? "yellow" : "lightGrey"} />
                </div>
            </div>
        </div>
    );
};

export default Footer;
